import { state } from '@angular/animations';
import { createUrlResolverWithoutPackagePrefix } from '@angular/compiler';
import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as AuthReducer from './redirect/redirect.actions';
import * as HeaderActions from './shared/header.actions';
import * as AppAction from './app.actions';
import { Signin } from './signin.interface';


export const userconfirmedFeatureKey = 'userconfirmed';

export interface State {
  confirm: boolean;
  prompt: number;
  Token: any;
  UUID: string;
}

export const initialState: State = {
  confirm: null,
  prompt: 0,
  Token: null,
  UUID: null,
};


export const userConfirmedReducer = createReducer(
  initialState,
  on(AuthReducer.unconfirmedAccount, (userConfirmedState, action) => ({
    ...userConfirmedState,
    confirm: false
  })),
  on(HeaderActions.loadConfirmModal, userConfirmedState => ({
    ...userConfirmedState,
    prompt: userConfirmedState.prompt + 1
  })),
  on(AuthReducer.unconfirmedAccount, (userConfirmedState, action: {data: {Token: string, UUID: string}, type: string}) => ({
    ...userConfirmedState,
    ...action.data
  })),


);

export function reducer(userConfirmedState: State | undefined, action: Action) {
  return userConfirmedReducer(userConfirmedState, action);
}

export const selectUserConfirmed =
createFeatureSelector<State>(userconfirmedFeatureKey);

export const selectIsConfirmed = createSelector(
  selectUserConfirmed,
  (userconfirmed: State) => userconfirmed.confirm
);

export const selectConfirmInfo = createSelector(
  selectUserConfirmed,
  (userconfirm: State) => ({Token: userconfirm.Token, UUID: userconfirm.UUID})
);

